import { render, staticRenderFns } from "./UIEventItemsForMemberEdit.vue?vue&type=template&id=50d2b76a&scoped=true&"
import script from "./UIEventItemsForMemberEdit.vue?vue&type=script&lang=js&"
export * from "./UIEventItemsForMemberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d2b76a",
  null
  
)

export default component.exports